import Vue from 'vue';
import _ from 'lodash';
import store, {storage, API_CLIENT} from '@/store';
import i18n from '@/i18n';
import {addValidationTranslations} from "@/utils/auth/validation";

function getSlugFromUrl() {
  return API_CLIENT || window.location.href.match(/.*\/web2?\/([\w.-]+)\/.*/i)[1];
}

async function setLocale(locale, persistLocale = true) {
  await store.dispatch('setLocale', locale);
  i18n.locale = locale;

  if (persistLocale) {
    storage.setItem('selectedLocale', locale);
  }

  Vue.axios.defaults.headers['Accept-Language'] = locale;
}

function getBrowserLanguage() {
  if (typeof navigator !== 'undefined') {
    const language =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage

    if (language) {
      return language.split('-')[0].toLowerCase()
    }

    return ''
  }

  return ''
}

async function mergeCustomTranslations() {
  try {
    await store.dispatch('getCustomTranslations');
    const customTranslations = store.state.customTranslations;

    Object.keys(customTranslations).forEach((key) => {
      i18n.mergeLocaleMessage(key, customTranslations[key]);
    })
  } catch (error) {
    console.log('error merging custom translations', error);
  }
}

async function setAppLanguage(userLocale) {
  if (userLocale) {
    const locale = userLocale.split('-')[0]
    const availableLanguages = _.get(store.getters.extensionSettings, 'i18n.languages', [])
    const fallbackLanguage = _.get(store.getters.extensionSettings, 'i18n.fallback_language')

    if (fallbackLanguage) {
      i18n.fallbackLocale = fallbackLanguage
    }

    if (_.includes(availableLanguages, locale)) {
      await setLocale(locale, false)
      return
    }

    if (fallbackLanguage) {
      await setLocale(fallbackLanguage, false)
      return
    }
  }

  let appLanguage
  let shouldPersistLanguage
  const selectedLocale = storage.getItem('selectedLocale')

  if (selectedLocale) {
    appLanguage = selectedLocale
    shouldPersistLanguage = true
  } else {
    const browserLanguage = getBrowserLanguage()
    const fallbackLanguage = storage.getItem('fallbackLanguage')
    const unknownLanguage = storage.getItem('unknownLanguage')
    const availableLanguages = storage.getItem('availableLanguages')

    if (browserLanguage && availableLanguages && fallbackLanguage) {
      appLanguage = _.includes(availableLanguages, browserLanguage) ? browserLanguage : fallbackLanguage
    } else {
      appLanguage = unknownLanguage || browserLanguage || i18n.locale
    }

    shouldPersistLanguage = false
  }

  await setLocale(appLanguage, shouldPersistLanguage)
  await mergeCustomTranslations()

  addValidationTranslations(store.state.locale)
}

function filterValidChars(text) {
  if (text) {
    return text.replace(/\D+/g, '')
  }

  return ''
}

function isNonEmptyString(string) {
  return _.isString(string) && string.trim() !== ''
}

function removeServiceWorkers() {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister()
    }
  })
}

export {
  getSlugFromUrl,
  setLocale,
  getBrowserLanguage,
  setAppLanguage,
  mergeCustomTranslations,
  filterValidChars,
  removeServiceWorkers,
  isNonEmptyString
}
